import { getWorkflowOpenTasks } from './get-workflow-open-tasks';
import {
  addressReviewTaskPredicate,
  buildFormTaskPredicate,
  reviewFormTaskPredicate,
  viewCompleteFormTaskPredicate,
  viewReviewTaskPredicate,
} from '../types/predicates';
import { IWorkflowInstance } from '../types/workflow-instance.interface';
import { IWorkflowPermissions } from '../types/workflow-permissions.interface';

export const getWorkflowOpenTaskPermissions = (workflowInstance: IWorkflowInstance, chimeraUserId?: string) => {
  const workflowOpenTasks = getWorkflowOpenTasks(workflowInstance, chimeraUserId);
  const canAddressReview = !!workflowOpenTasks.find(addressReviewTaskPredicate);
  const canBuildForm = !!workflowOpenTasks.find(buildFormTaskPredicate);
  const canReviewForm = !!workflowOpenTasks.find(reviewFormTaskPredicate);
  const canViewReview = !!workflowOpenTasks.find(viewReviewTaskPredicate);
  const canViewCompleteForm = !!workflowOpenTasks.find(viewCompleteFormTaskPredicate);
  const canEditAudit = canReviewForm && canViewReview;

  return {
    canAddressReview,
    canBuildForm,
    canReviewForm,
    canViewReview,
    canViewCompleteForm,
    canEditAudit,
  } as IWorkflowPermissions;
};
